import React from 'react';
import config from 'coeus.config';
import { Grid } from '@material-ui/core';
import SectionCard from 'components/common/SectionCard';
import { useHistory } from 'react-router-dom';

const CustomDashboardPages = () => {
    const history = useHistory();
    const { dashboard } = config;

    const customActions = (item) => {
        const { label, icon, location } = item;
        return [
            {
                label,
                Icon: icon,
                onClick: () => history.push(location),
            },
        ];
    };

    return (
        <>
            {dashboard &&
                dashboard.custom &&
                dashboard.custom.map((item) => (
                    <Grid item lg={3} md={4} sm={6} xs={12} key={item.title}>
                        <SectionCard
                            {...item}
                            actions={customActions(item.actions)}
                        />
                    </Grid>
                ))}
        </>
    );
};

export default CustomDashboardPages;
